import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealWorkflowRestriction } from "~/models/DealWorkflowRestriction";
import { generatePath } from "~/utils/generatePath";

const paths = {
	show: "/deals/:deal_id/deal_workflow_restriction"
} as const;

export const useDealWorkflowRestriction = (
	dealId: number
): SwrReturnType<DealWorkflowRestriction> => {
	const { data, mutate, error, isLoading } = useSWR<DealWorkflowRestriction>(
		generatePath(paths.show, { deal_id: dealId })
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
